export default function parseJson(...args) {
    const [value] = args;
    return value === null ? undefined : JSON.parse(...args);
}
//# sourceMappingURL=parseJson.js.map